import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/core/interfaces/component-can-deactive.interface';

@Injectable({
    providedIn: 'root'
})

export class UnSavedGuard implements CanDeactivate<ComponentCanDeactivate> {

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
        if(component.canDeactivate()) {
          return true;
        } else {
          return confirm('Discard unsaved changes?');
        }
      }

}
